import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Roles } from '@cure-common/enum';

import { JwtService } from '../services';

export const RoleGuard = (role: Roles): CanActivateFn => {
  return () => {
    const router = inject(Router);
    const jwtService: JwtService = inject(JwtService);

    const isAdmin = jwtService.getRoleFromToken() === role;
    if (!isAdmin) {
      return router.navigate(['/working-hours']);
    }
    return isAdmin;
  };
};
